import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function BackupPanel() {
  const [backups, setBackups] = useState([]);
  const [creating, setCreating] = useState(false);
  const [restoring, setRestoring] = useState(null);
  const [msg, setMsg] = useState(null);

  const fetchBackups = () => {
    api.get('/admin/backups').then(setBackups).catch(() => {});
  };

  useEffect(fetchBackups, []);

  const handleCreate = async () => {
    setCreating(true);
    setMsg(null);
    try {
      const data = await api.post('/admin/backup/export');
      setMsg({ type: 'success', text: `Backup created successfully. ${data.filename} (${(data.size / 1024).toFixed(1)} KB)` });
      fetchBackups();
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setCreating(false);
    }
  };

  const handleRestore = async (filename) => {
    if (!window.confirm(`Restore from ${filename}? This may overwrite current data.`)) return;
    setRestoring(filename);
    setMsg(null);
    try {
      await api.post('/admin/backup/import', { filename });
      setMsg({ type: 'success', text: `Restored: ${filename}` });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setRestoring(null);
    }
  };

  const fmtSize = (b) => b < 1024 ? b + ' B' : b < 1048576 ? (b / 1024).toFixed(1) + ' KB' : (b / 1048576).toFixed(1) + ' MB';

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Database Backups</h3>

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 13,
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}

      <button className="btn-primary btn-small" onClick={handleCreate} disabled={creating} style={{ marginBottom: 12 }}>
        {creating ? 'Creating...' : 'Create Backup Now'}
      </button>

      {backups.length === 0 ? (
        <div className="empty-state" style={{ padding: 20, fontSize: 13 }}>No backups yet</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {backups.map(b => (
            <div key={b.filename} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--border)',
            }}>
              <div>
                <div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600 }}>{b.filename}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                  {fmtSize(b.size)} &middot; {new Date(b.created).toLocaleString()}
                </div>
              </div>
              <button
                className="btn-secondary btn-small"
                onClick={() => handleRestore(b.filename)}
                disabled={restoring === b.filename}
              >
                {restoring === b.filename ? '...' : 'Restore'}
              </button>
            </div>
          ))}
        </div>
      )}

      <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 8, marginBottom: 0 }}>
        Auto-backup every 2hrs. 5 most recent kept.
      </p>
    </div>
  );
}
